import { render } from "./coupons-list.vue?vue&type=template&id=5a7180bc&scoped=true"
import script from "./coupons-list.vue?vue&type=script&lang=js"
export * from "./coupons-list.vue?vue&type=script&lang=js"

import "./coupons-list.vue?vue&type=style&index=0&id=5a7180bc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a7180bc"]])

export default __exports__